var React = require('react');

function Defying (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .forms {\n        fill:#e5fd57;\n        stroke:#000;\n        stroke-miterlimit:10;\n      }\n    ")),React.createElement("path",{"className":"forms","d":"M.5,68.49v339c0,37.55,67.3,68,150.32,68s150.33-30.44,150.33-68v-339c0-37.55-67.3-68-150.33-68S.5,30.94.5,68.49Z","key":1})]);
}

Defying.defaultProps = {"id":"defying","data-name":"defying","viewBox":"0 0 301.65 475.98"};

module.exports = Defying;

Defying.default = Defying;
